export default {
  header: {
    title: "Centre d'aide",
  },
  home: {
    search: {
      title: "Bonjour ! Comment pouvons-nous vous aider ?",
      subtitle: "",
      placeholder: "Recherche dans les guides",
    },
    householder: "Je suis un propriétaire",
    installer: "Je suis un installateur",
  },
  householder: {
    title: "Tous les sujets",
    subtitle: "Parcourez notre bibliothèque complète de rubriques d'aide.",
    guides: {
      "your-internet-portal": {
        title: "Votre portail internet",
        description:
          "Instructions faciles à suivre pour créer un compte et gérer son espace en ligne.",
      },
      "payments-pricing-and-refunds": {
        title: "Paiements, tarification et remboursements",
        description:
          "Marche à suivre pour percevoir pleinement son gain économique, comparer les prix euro-watts-crête, régler l’acompte et le solde, et télécharger les factures et reçus.",
      },
      "choose-your-solar-system": {
        title: "Choisir son système solaire",
        description:
          "Comment bénéficier d’une étude de votre pourcentage d’autonomie électrique, et donc de vos économies, par rapport à différentes alternatives de votre projet solaire.",
      },
      "choosing-a-customised-quote": {
        title: "Choisir son devis sur-mesure",
        description:
          "Comment sélectionner parmi plusieurs propositions complètes, détaillés et sur-mesure d’installateurs photovoltaïques proches de chez vous.",
      },
      "validate-feasibility": {
        title: "Valider la faisabilité",
        description:
          "Comment planifier puis se préparer pour la rencontre avec le technicien, et se faire réaliser la faisabilité technique  chez vous du cahier des charges.",
      },
      "investing-in-solar": {
        title: "Investir dans le solaire",
        description:
          "Comment contrôler les assurances et certifications du maitre d’œuvre, signer électroniquement son devis définitif, et régler l’acompte en toute sécurité.",
      },
      "carrying-out-administrative-procedures": {
        title: "Réalisation des démarches administratives",
        description:
          "Comment suivre l’obtention de l’autorisation de l’urbanisme auprès de la mairie, puis planifier l’installation photovoltaïque.",
      },
      "installation-and-commissioning": {
        title: "Pose & mise en service",
        description:
          "Comment valoriser l’injection du surplus avec un raccordement au réseau électrique respectant les normes en vigueur.",
      },
      "legal-notices": {
        title: "Mentions juridiques",
        description:
          "Informations sur la relation contractuelle entre nous et le professionnel photovoltaïque, avec aperçu des conditions générales.",
      },
    },
    cta: {
      title: "Discover others solar journey",
      subtitle:
        "Quasi est quaerat. Sit molestiae et. Provident ad dolorem occaecati eos iste. Soluta rerum quidem minus ut molestiae velit error quod. Excepturi quidem expedita molestias quas.",
      description:
        "Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui lorem cupidatat commodo. Elit sunt amet fugiat veniam occaecat fugiat. Quasi aperiam sit non sit neque reprehenderit.",
      button: "Join our team",
    },
  },
  installer: {
    title: "Tous les sujets",
    subtitle: "Tous les sujets",
    guides: {
      "your-online-account": {
        title: "Votre compte en ligne",
        description:
          "Instructions faciles à suivre pour créer un compte et gérer son espace professionnel.",
      },
      "your-solar-projects": {
        title: "Vos projets solaires",
        description:
          "Instructions simples à suivre pour la gestion et le suivi de prospects, devis, dossiers puis chantiers photovoltaïques sur une seule interface en ligne.",
      },
      "online-photovoltaic-studies": {
        title: "Études photovoltaïques en ligne",
        description:
          "Tout savoir sur comment mieux vendre avec nos présentations personnalisables, vos propositions sur-mesure de systèmes solaires, et notre méthode technico-financière.",
      },
      "dematerialised-administrative-management": {
        title: "Gestion administrative automatisée",
        description:
          "Tout savoir sur comment gagner du temps avec nos services numériques d’envoi et de suivi des démarches administratives obligatoires pour installations photovoltaïques.",
      },
      "contact-and-quotation-proposals": {
        title: "Mise en relation",
        description:
          "Tout savoir sur les signatures électroniques, les paiements automatiques sur internet, la mise en conformité, le service d’assistance de maîtrise d’ouvrage, et bien plus encore. ",
      },
      "materials-planning": {
        title: "Planification du matériel",
        description:
          "Tout savoir sur les listes de matériel de l’entreprise, kits personnalisables, approvisionnement et gestion du stock, comptes rendus de chantiers, et bien plus encore.",
      },
      "after-sales-service": {
        title: "Service après-installation",
        description:
          "Tout savoir sur la responsabilité de chacun, communication entre le maitre d’ouvrage et le maitre d’œuvre, l’entretien, le suivi de rendements, le dépannage et le nettoyage.",
      },
      "payments-pricing-and-refunds": {
        title: "Paiements, tarification et remboursements",
        description:
          "Marche à suivre pour percevoir de l’argent, gagner du chiffre d’affaires, acheter au travers de la boutique en ligne, et télécharger les factures comptables.",
      },
      "legal-notices": {
        title: "Mentions juridiques",
        description:
          "Informations sur la relation contractuelle entre nous et le professionnel photovoltaïque, avec aperçu des conditions générales mentions légales.",
      },
    },
    cta: {
      title: "Optez pour la technologie",
      description:
        "Notre technologie numérique vous permet de gérer collaborativement en équipe l'ensemble des étapes de vos projets solaires.",
      benefit: {
        benefit1: "Gestion des chantiers",
        benefit2: "Gestion d'agenda",
        benefit3: "Gestion du matériel",
        benefit4: "Paiements sécurisés",
        benefit5: "Signatures électroniques",
        benefit6: "Notifications email",
      },
      button: "Ouvrir un compte",
    },
  },
  "side-bar": {
    "bread-crumb": {
      home: "Accueil",
      help: "Centre d'aide",
      "your-account": "Votre compte",
      "manage-your-projects": "Gérez vos projets",
      presentation: "Étude",
      administration: "Administration",
      "quoting-and-invoicing": "Devis et facturation",
      "scheduling-your-hardware": "Planification de votre matériel",
      "post-installation": "Après l'installation",
      payments: "Paiements",
      legal: "Légal",
    },
    summary: "Sommaire",
    shortcut: {
      support: {
        title: "Contact support",
        description: "Prenez contact avec nos équipes",
        others: "Autres articles",
      },
    },
    search: "Rechercher...",
  },
}
